import { Stack } from '@fluentui/react';

import Note from './Note';
import Serial from './Serial';
import SpecialOrder from './SpecialOrder';

export default () => {
  return (
    <Stack tokens={stackTokens}>
      <Stack horizontal>
        <Stack.Item grow>
          <SpecialOrder />
        </Stack.Item>
        <Stack.Item grow>
          <Serial />
        </Stack.Item>
      </Stack>
      <Note />
    </Stack>
  );
};

const stackTokens = { childrenGap: 5 };
